
import React, { useEffect, useState } from 'react';

import moment from 'moment';

import { Button } from 'antd';

import { HomesDatePicker } from '../../details/date-picker/component';

import './style.scss';

interface ILuxuryDates {
  checkIn: string | null | undefined;
  checkOut: string | null | undefined;
}

interface IProps {
  dates: ILuxuryDates | null;
  disabled?: boolean;

  onDatesChange: (dates: ILuxuryDates | null) => void;
}

export const LuxuryHomesDatesFilters: React.FC<IProps> = ({ dates, onDatesChange, disabled }) => {
  const [selectedDates, setSelectedDates] = useState<ILuxuryDates | null>(dates);

  useEffect(() => {
    setSelectedDates(dates);
    
    if(!dates?.checkIn && !dates?.checkOut) {
      onDatesChange(null);
    }
  }, [dates]);

  useEffect(() => {
    if(!selectedDates?.checkIn && !selectedDates?.checkOut) {
      onDatesChange(null);
    }
  }, [selectedDates]);

  const disabledDates = !selectedDates?.checkIn || !selectedDates?.checkOut || (selectedDates?.checkIn === selectedDates?.checkOut);

  return (
    <div className="featured-properties__filters dates-filters">
      <HomesDatePicker 
        startDate={selectedDates?.checkIn ? moment(selectedDates?.checkIn, 'YYYY-MM-DD').toDate() : null}
        endDate={selectedDates?.checkOut ? moment(selectedDates?.checkOut, 'YYYY-MM-DD').toDate() : null}
        
        setStartDate={(date: Date | null | undefined) => {
          setSelectedDates(prev => ({
            checkIn: date ? moment(date).format('YYYY-MM-DD') : undefined,
            checkOut: prev?.checkOut || undefined
          }));
        }}

        setEndDate={(date: Date | null | undefined) => {
          setSelectedDates(prev => ({
            checkIn: prev?.checkIn || undefined,
            checkOut: date ? moment(date).format('YYYY-MM-DD') : undefined
          }));
        }}

        setError={() => {}}
        setEditDates={() => {}}
        error={''}
        
        leftAlign
        editDates
      />

      <Button type="primary" className="dates-filters__button" disabled={disabledDates || disabled} onClick={() => onDatesChange(selectedDates)}>
        {disabledDates ? 'Select Dates' : 'Apply Dates'}
      </Button>
    </div>
  );
};
